import { Route } from '@angular/router';
import { crmLandingRoute } from './crm-route.helpers';

const LEADS_CRUMB = { id: 'leads', label: 'Leads' };
const CATALOGS_CRUMB = { id: 'catalogs', label: 'Catálogos' };
const REPORTS_CRUMB = { id: 'reports', label: 'Reportes' };

export const CRM_LEADS_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'leads/tracking/tracking',
    moduleId: 'leads',
    activeMenubarId: 'leads-tracking',
    title: 'Seguimiento',
    breadcrumbs: [LEADS_CRUMB, { id: 'tracking', label: 'Seguimiento' }],
    loadComponent: () =>
      import('../pages/leads/tracking/tracking/tracking.component').then(
        (m) => m.LeadsTrackingComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/ranking/ranking',
    moduleId: 'leads',
    activeMenubarId: 'leads-ranking',
    title: 'Ranking',
    breadcrumbs: [LEADS_CRUMB, { id: 'ranking', label: 'Ranking' }],
    loadComponent: () =>
      import('../pages/leads/ranking/ranking/ranking.component').then(
        (m) => m.LeadsRankingComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/appointments/appointments',
    moduleId: 'leads',
    activeMenubarId: 'leads-citas',
    title: 'Citas',
    breadcrumbs: [LEADS_CRUMB, { id: 'appointments', label: 'Citas' }],
    loadComponent: () =>
      import(
        '../pages/leads/appointments/appointments/appointments.component'
      ).then((m) => m.LeadsAppointmentsComponent),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/processes',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-processes',
    title: 'Procesos',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'processes', label: 'Procesos' },
    ],
    loadComponent: () =>
      import('../pages/leads/catalogs/processes/processes.component').then(
        (m) => m.LeadsProcessesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/stage-types',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-stage-types',
    title: 'Tipos de etapas',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'stage-types', label: 'Tipos de etapas' },
    ],
    loadComponent: () =>
      import('../pages/leads/catalogs/stage-types/stage-types.component').then(
        (m) => m.LeadsStageTypesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/media',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-media',
    title: 'Medios',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'media', label: 'Medios' },
    ],
    loadComponent: () =>
      import('../pages/leads/catalogs/media/media.component').then(
        (m) => m.LeadsMediaComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/sources',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-sources',
    title: 'Fuentes',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'sources', label: 'Fuentes' },
    ],
    loadComponent: () =>
      import('../pages/leads/catalogs/sources/sources.component').then(
        (m) => m.LeadsSourcesComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/activity-types',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-activity-types',
    title: 'Tipos de actividades',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'activity-types', label: 'Tipos de actividades' },
    ],
    loadComponent: () =>
      import(
        '../pages/leads/catalogs/activity-types/activity-types.component'
      ).then((m) => m.LeadsActivityTypesComponent),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/lost-reasons',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-lost-reasons',
    title: 'Razones de perdido',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'lost-reasons', label: 'Razones de perdido' },
    ],
    loadComponent: () =>
      import(
        '../pages/leads/catalogs/lost-reasons/lost-reasons.component'
      ).then((m) => m.LeadsLostReasonsComponent),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/reactivation-reasons',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-reactivation-reasons',
    title: 'Razones de reactivación',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      { id: 'reactivation-reasons', label: 'Razones de reactivación' },
    ],
    loadComponent: () =>
      import(
        '../pages/leads/catalogs/reactivation-reasons/reactivation-reasons.component'
      ).then((m) => m.LeadsReactivationReasonsComponent),
  }),
  crmLandingRoute({
    path: 'leads/catalogs/automated-follow-up-reasons',
    moduleId: 'leads',
    activeMenubarId: 'leads-cat-auto-follow-reasons',
    title: 'Razones seguimiento automatizado',
    breadcrumbs: [
      LEADS_CRUMB,
      CATALOGS_CRUMB,
      {
        id: 'automated-follow-up-reasons',
        label: 'Razones seguimiento automatizado',
      },
    ],
    loadComponent: () =>
      import(
        '../pages/leads/catalogs/automated-follow-up-reasons/automated-follow-up-reasons.component'
      ).then((m) => m.LeadsAutomatedFollowUpReasonsComponent),
  }),
  crmLandingRoute({
    path: 'leads/reports/leads',
    moduleId: 'leads',
    activeMenubarId: 'leads-rep-leads',
    title: 'Leads',
    breadcrumbs: [
      LEADS_CRUMB,
      REPORTS_CRUMB,
      { id: 'leads-report', label: 'Leads' },
    ],
    loadComponent: () =>
      import('../pages/leads/reports/leads/leads-report.component').then(
        (m) => m.LeadsReportComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/reports/sales-funnel',
    moduleId: 'leads',
    activeMenubarId: 'leads-rep-funnel',
    title: 'Funnel de ventas',
    breadcrumbs: [
      LEADS_CRUMB,
      REPORTS_CRUMB,
      { id: 'sales-funnel', label: 'Funnel de ventas' },
    ],
    loadComponent: () =>
      import('../pages/leads/reports/sales-funnel/sales-funnel.component').then(
        (m) => m.LeadsSalesFunnelReportComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/reports/lost-leads',
    moduleId: 'leads',
    activeMenubarId: 'leads-rep-lost',
    title: 'Leads perdidos',
    breadcrumbs: [
      LEADS_CRUMB,
      REPORTS_CRUMB,
      { id: 'lost-leads', label: 'Leads perdidos' },
    ],
    loadComponent: () =>
      import('../pages/leads/reports/lost-leads/lost-leads.component').then(
        (m) => m.LostLeadsReportComponent,
      ),
  }),
  crmLandingRoute({
    path: 'leads/reports/reconciliation',
    moduleId: 'leads',
    activeMenubarId: 'leads-rep-conciliation',
    title: 'Conciliación',
    breadcrumbs: [
      LEADS_CRUMB,
      REPORTS_CRUMB,
      { id: 'reconciliation', label: 'Conciliación' },
    ],
    loadComponent: () =>
      import(
        '../pages/leads/reports/reconciliation/reconciliation.component'
      ).then((m) => m.LeadsReconciliationReportComponent),
  }),
  crmLandingRoute({
    path: 'leads/reports/assignments',
    moduleId: 'leads',
    activeMenubarId: 'leads-rep-assignments',
    title: 'Asignaciones',
    breadcrumbs: [
      LEADS_CRUMB,
      REPORTS_CRUMB,
      { id: 'assignments', label: 'Asignaciones' },
    ],
    loadComponent: () =>
      import('../pages/leads/reports/assignments/assignments.component').then(
        (m) => m.LeadsAssignmentsReportComponent,
      ),
  }),
];
